export const phishing_indices =
    [0, 1, 2, 3, 4, 5]
;